module.exports = __webpack_public_path__ + "img/icon-bofang.9dd4d21f.png";